




































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Translation from '@/components/i18n/Translation.vue';
import FormField from '@/components/form/FormField.vue';
import DatePicker from 'vuejs-datepicker';
import moment, { Moment } from 'moment';
import { ValidationError } from 'class-validator';
import Select from '@/components/form/Select.vue';
import SelectOption from '@/types/form/SelectOption';
import i18next from 'i18next';

@Component({
  components: { Select, Translation, FormField, DatePicker },
})
export default class BirthdayField extends Vue {
  @Prop(Object)
  public value!: Moment;

  @Prop(String)
  public identifier!: string;

  @Prop(String)
  public label!: string;

  @Prop(Boolean)
  public disabled!: boolean;

  @Prop(Boolean)
  public hasInfo!: boolean;

  @Prop(Boolean)
  public isMandatory!: boolean;

  @Prop(Boolean)
  public isLocal!: boolean;

  @Prop(Object)
  public validationError!: ValidationError | null;

  public day: number = 0;
  public month: number = 0;
  public year: number = 0;
  // public hours: number = 0;
  // public minutes: number = 0;
  // public seconds: number = 0;
  // public utcOffset: number = 0;

  @Emit()
  public infoClick(): void {}

  public mounted(): void {
    if (this.value && this.value.isValid()) {
      let birthday;
      if (!this.isLocal) {
        birthday = moment.utc(this.value).local();
      } else {
        birthday = this.value;
      }
      this.day = birthday.date();
      this.month = birthday.month() + 1;
      this.year = birthday.year();
      // this.hours = birthday.hours();
      // this.minutes = birthday.minutes();
      // this.seconds = birthday.seconds();
      // this.utcOffset = birthday.utcOffset();
      // console.log("On Mounted Birthday", birthday);
    }
  }

  public currentYear(): number {
    return moment().year();
  }

  public numberOptions(defaultLabel: string, from: number, to: number, reverse: boolean = false): SelectOption[] {
    let result = [];
    for (let i = from; i <= to; i++) {
      result.push({ value: i, label: `${i}` });
    }
    if (reverse) {
      result = result.reverse();
    }
    return [{ value: 0, label: defaultLabel }, ...result];
  }

  public translate(path: string, params?: any): string {
    return i18next.t(path, params);
  }

  public setValue(value: string, unit: string): void {
    if (unit === 'day') {
      this.day = parseInt(value);
    } else if (unit === 'month') {
      this.month = parseInt(value);
    } else if (unit === 'year') {
      this.year = parseInt(value);
    }

    let date: Moment | null = moment();

    if (this.year === 0 || this.month === 0 || this.day === 0) {
      date = null;
    } else {
      date.date(this.day);
      date.month(this.month - 1);
      date.year(this.year);
      date.hours(0);
      date.minutes(0);
      date.seconds(0);
      date.milliseconds(0);
    }
    
    let finalDate: Moment | null = null;
    if (date != null) {
      if (this.isLocal) {
        finalDate = date;
      } else {
        finalDate = date.utc();
      }
    }
    this.$emit('input', finalDate);
  }

  @Watch('value', { immediate: true })
  public onBirthdateValueChange(birthdate: Moment) {
    if((!birthdate || !birthdate.isValid()) && (this.day != 0 && this.month != 0 && this.year != 0)) {
      this.day = 0;
      this.month = 0;
      this.year = 0;
    }
  }  
}
